// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"368":"7b4020e6","608":"f45c427b"}[chunkId] + ".chunk.js";
};